import React, { useState } from 'react';
import FAQs from '../../../shared-components/FAQs/FAQs';
import { EPageType, Faq } from '../../../types/pages/things-to-do';

interface IProps {
  faqs: Faq[];
}

export const FaqSection = ({ faqs }: IProps) => {
  const [openSections, setOpenSections] = useState<{
    requirement: string | null;
    faq: string | null;
  }>({ requirement: null, faq: null });

  const toggleSection = (sectionType: string, index: number) => {
    setOpenSections((prevOpenSections: any) => ({
      ...prevOpenSections,
      [sectionType]:
        prevOpenSections[sectionType] === String(index) ? null : String(index)
    }));
  };

  return (
    <div className="bg-bluishGray py-8">
      <div className="w-[90%] md:w-[85%] xl:w-[80%] 3xl:w-[70%] mx-auto flex flex-col xxsm:px-2 sm:px-0">
        <h1
          className="text-black13 xxsm:text-[22px] sm:text-[26px] xl:text-[32px] font-semibold
capitalize leading-9"
        >
          FAQs
        </h1>
        <div className="w-full h-full flex flex-col xxsm:items-center xsm:mt-[10px] md:mt-[20px]">
          {faqs?.length > 0 ? (
            faqs?.map((section, index) => (
              <FAQs
                pageType={EPageType.THINGS_TODO}
                key={index}
                faqSection={section}
                index={index}
                sectionType={'requirement'}
                isOpen={openSections.faq === String(index)}
                toggleSection={() => toggleSection('faq', index)}
              />
            ))
          ) : (
            <p>No Faqs Available</p>
          )}
        </div>
      </div>
    </div>
  );
};
